import Accordion from '@components/Accordion';
import Button from '@components/Button';
import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import useGiftBox from '@hooks/gift/useGiftBox';
import { GiftBoxType, GiftItemType } from '@models/gift';
import { Link } from '@router/Link';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import GiftHeader from './components/GiftHeader';
import GiftItem from './components/GiftItem';
import GiftMessage from './components/GiftMessage';
import UseInfo from './components/UseInfo';

interface Params {
    giftBoxItemId: string;
    giftItemType: GiftItemType;
}
const GiftReceivedActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { giftBoxItemId, giftItemType } = params;
    const giftBox = useGiftBox(giftBoxItemId, {
        giftItemType, giftBoxType: GiftBoxType.RECEIVED,
    });
    const { t } = useTranslation('gift');
    const contents = <Fragment>
        <GiftHeader/>
        {giftBox && (
            <GiftItem giftBox={giftBox}/>
        )}
        {giftBox?.giftItemType === 'PRODUCT' && (
            <UseInfo/>
        )}
        <GiftMessage/>
        <Divider/>
        <Accordion title={t('giftReceived.noteTitle')} >

        </Accordion>
    </Fragment>;
    return (
        <AppScreen>
            {giftBox?.giftItemType === 'PRODUCT' ? (
                <Column fullWidth>
                    <Header title={t('giftReceived.title')} />
                    {contents}
                </Column>
            ) : (
                <CtaLayout header={<Header title={t('giftReceived.title')} />}
                    footer={<Link activityParams={{}}
                        activityName='MainActivity' >
                        <Button fullWidth>
                            {t('giftReceived.useGift')}
                        </Button>
                    </Link>}
                    noFooterBorder>
                    {contents}
                </CtaLayout>
            )}
        </AppScreen>
    );
};

export default GiftReceivedActivity;
